import { IAuthRoute } from "./interfaces";
import { AUTH_ROUTE_DEFAULTS } from "./helper";

export class AuthRoute implements IAuthRoute {
  LoginSegment?: string;
  RegisterSegment?: string;
  LogOutSegment?: string;
  RefreshSegment?: string;
  ChangePasswordSegment?: string;
  ResetPasswordSegment?: string;
  ToogleDisabledSegment?: string;
  LoginUrl?: string;
  ChangePasswordUrl?: string;

  constructor(config: IAuthRoute = {}) {
    for (const option in config) {
      this[option] = config[option];
    }

    for (const option in AUTH_ROUTE_DEFAULTS) {
      this[option] =
        config[option] != null ? config[option] : AUTH_ROUTE_DEFAULTS[option];
    }
  }
}
